module.exports = __webpack_public_path__ + "img/pdf.dc3fd3e1.svg";